import { db, auth } from './init';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

export const trackVisit = async (to) => {
  try {
    const user = auth.currentUser;
    const visitData = {
      path: to.path,
      name: to.name || 'unknown',
      timestamp: serverTimestamp(),
      userId: user ? user.uid : null,
      userEmail: user ? user.email : null,
      userAgent: navigator.userAgent
    };

    await addDoc(collection(db, 'page_visits'), visitData);
  } catch (error) {
    console.error('Error tracking visit:', error);
  }
};

